module.exports = __webpack_public_path__ + "img/transformer.f38532ef.png";